import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { MESSAGEBOX_TYPES, MESSAGEBOX_VIEWS } from 'src/constants/constants';
import classNames from 'classnames';
import List from 'src/ui/library/List';
import intl from 'react-intl-universal';

export default function MenuPres({
  countInbox,
  countSent,
  countDrafts,
  isMobile,
  isTablet,
  selectMenu,
  selectedMenu,
  selectMenuAndReset,
  switchView,
  toggleDrawer,
}) {
  const { INBOX, SENT, DRAFT } = MESSAGEBOX_TYPES;
  const inboxSelected = classNames({ selected: selectedMenu === INBOX });
  const sentSelected = classNames({ selected: selectedMenu === SENT });
  const draftSelected = classNames({ selected: selectedMenu === DRAFT });
  countInbox = countInbox > 0 ? countInbox : 0;
  countSent = countSent > 0 ? countSent : 0;
  countDrafts = countDrafts > 0 ? countDrafts : 0;

  const menuConfig = [
    {
      className: `menu-item ${inboxSelected}`,
      onClickAction: MESSAGEBOX_TYPES.INBOX,
      selected: selectedMenu === INBOX,
      title: `${intl.get('messaging.inbox')} (${countInbox})`,
    },
    {
      className: `menu-item ${sentSelected}`,
      onClickAction: MESSAGEBOX_TYPES.SENT,
      selected: selectedMenu === SENT,
      title: `${intl.get('messaging.sent')} (${countSent})`,
    },
    {
      className: `menu-item ${draftSelected}`,
      onClickAction: MESSAGEBOX_TYPES.DRAFT,
      selected: selectedMenu === DRAFT,
      title: `${intl.get('messaging.draft')} (${countDrafts})`,
    },
  ];

  const menuClicked = item => {
    if (item === selectedMenu) return false;

    selectMenuAndReset(item);
    switchView(MESSAGEBOX_VIEWS.LIST);
    if (isMobile) {
      toggleDrawer('left');
    }
  };

  return (
    <Fragment>
      <List config={menuConfig} isMobile={isMobile} isTablet={isTablet} onClick={menuClicked} styleType="secondary" subheader="Mailboxes" />
    </Fragment>
  );
}

MenuPres.propTypes = {
  selectedMenu: PropTypes.string,
  selectMenuAndReset: PropTypes.func.isRequired,
  countInbox: PropTypes.number.isRequired,
  countSent: PropTypes.number.isRequired,
  countDrafts: PropTypes.number.isRequired,
  switchView: PropTypes.func.isRequired,
};
